import { useEffect, useState } from "react";
import { keys } from "../../../../constant/keyConfig";
import { useUserContext } from "../../../../context/userGetContext";
import { setItem } from "../../../../utils/localStorage";
import RootNavigator from "../../RootNavigator";
import { getLoader } from "../../../../utils/common";
import CenteredWrapper from "../../../../components/CenteredWrapper";

function UpdateTeamsContext({ contextInfo }) {
  const teamsContext = useUserContext();
  const { updateTeamsContext } = teamsContext;
  const [loadingctx, setLoadingCtx] = useState(true);
  setItem(keys.TEAMS_CONTEXT_KEY, contextInfo);
  updateTeamsContext(contextInfo);
  useEffect(() => {
    setTimeout(() => {
      setLoadingCtx(false);
    }, 0);
  }, []);
  if (loadingctx) {
    return (
      <CenteredWrapper>{getLoader(teamsContext?.app?.theme)}</CenteredWrapper>
    );
  }

  return <RootNavigator />;
}

export default UpdateTeamsContext;
